import { Outlet } from 'react-router-dom'
import { Footer, Header } from '../../component'
import { RootState } from '../../store'
import { useAppSelector } from '../../hook'
import { Menu } from '../../enum'
import './default.layout.scss'

interface DefaultLayoutProps {}

export const DefaultLayout = (props: DefaultLayoutProps) => {
    const menu = useAppSelector((state: RootState) => state.base.menu)

    return (
        <div className={`layout layout--default${Menu.Founds === menu || Menu.Cookies === menu || Menu.Impressum === menu || Menu.Terns === menu ? ` gray` : ``}`}>
            <Header />
            <Outlet />
            <Footer />
        </div>
    )
}
